import { memo, ReactNode } from 'react';
import { LayoutChangeEvent, StyleProp, ViewStyle } from 'react-native';
import Animated from 'react-native-reanimated';

export const CollapsibleContent = memo(
  ({
    style,
    contentStyle,
    children,
    onLayout,
  }: {
    style?: StyleProp<ViewStyle>;
    contentStyle?: StyleProp<ViewStyle>;
    children?: ReactNode;
    onLayout: (e: LayoutChangeEvent) => void;
  }) => {
    return (
      <Animated.View
        style={style}
        css={`
          overflow: hidden;
        `}
      >
        <Animated.View
          onLayout={onLayout}
          style={contentStyle}
          css={`
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
          `}
        >
          {children}
        </Animated.View>
      </Animated.View>
    );
  },
);
